export function getCategories(products) {
  return products.reduce((categories, product) => {
    let category = categories.find((cat) => cat.name === product.category_name);
    if (!category) {
      category = { name: product.category_name, products: [] };
      categories.push(category);
    }
    category.products.push(product);
    return categories;
  }, []);
}

export function calculateTotalAmountOfPriceWithDiscount(
  products,
  calculateDiscount
) {
  return products.reduce((total, product) => {
    const productTotal = calculateDiscount(product.eans) * product.amount;
    return total + productTotal;
  }, 0);
}

export function calculateTotalPrice(products) {
  return products.reduce((total, product) => {
    const productTotal = product.eans.reduce(
      (subTotal, ean) => subTotal + ean.price * product.amount,
      0
    );
    return total + productTotal;
  }, 0);
}

export function calculateTotalDiscountedPrice(orders, calculateDiscount) {
  return orders.reduce((total, order) => {
    const categories = getCategories(order.productsWithAmount);
    for (const category of categories) {
      total += calculateTotalAmountOfPriceWithDiscount(
        category.products,
        calculateDiscount
      );
    }
    return total;
  }, 0);
}
